import { Injector, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dynamicPipe',
    standalone: false
})
export class DynamicPipe implements PipeTransform {
    public constructor(private injector: Injector) {}

    transform(value: any, pipeToken: any, pipeArgs: any[]): any {
        if (!pipeToken) {
            return value;
        } else {
            let pipe = this.injector.get<PipeTransform>(pipeToken);
            return pipe.transform(value, ...pipeArgs);
        }
    }
}
